import * as yup from 'yup';

const adminAccountSchema = yup.object().shape({
  firstname: yup.string().required('common.required'),
  lastname: yup.string().required('common.required'),
  email: yup.string().email('common.errors.email').required('common.required'),
  role: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable().required('common.required'),
});

export default adminAccountSchema;
